"use strict";
module.exports = function () {
    var sizes = ["xs", "sm", "md", "lg", "xl"];

    sizes.forEach(function (size) {
        var selector = ".collapsible-" + size + " .title";

        $("body").on("click", selector, function (e) {
            e.preventDefault();

            var $this = $(this);
            var $thisCollapsibleParent = $this.parents(".collapsible-" + size);
            $thisCollapsibleParent.toggleClass("active");

            if ($thisCollapsibleParent.hasClass("active")) {
                $this.attr("aria-expanded", true);
            } else {
                $this.attr("aria-expanded", false);
            }
        });
    });
};
